/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ClientCohortDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getCohorts = (
  oktaUserId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ClientCohortDto[]>(
    { url: `/api/${oktaUserId}/cohorts`, method: 'GET', signal },
    options
  );
};

export const getGetCohortsQueryKey = (oktaUserId: string) => {
  return [`/api/${oktaUserId}/cohorts`] as const;
};

export const getGetCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortsQueryKey(oktaUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohorts>>> = ({
    signal,
  }) => getCohorts(oktaUserId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oktaUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohorts>>
>;
export type GetCohortsQueryError = ErrorType<unknown>;

export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCohorts<
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCohortsQueryOptions(oktaUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
